"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_google_maps_1 = require("@vis.gl/react-google-maps");
const react_1 = require("react");
const react_dom_1 = __importDefault(require("react-dom"));
const MapOverlay = ({ position, children }) => {
    const map = (0, react_google_maps_1.useMap)();
    const overlayRef = (0, react_1.useRef)(null);
    const containerElementRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (!map)
            return;
        class CustomOverlay extends google.maps.OverlayView {
            constructor() {
                super(...arguments);
                this.div = null;
            }
            onAdd() {
                this.div = document.createElement("div");
                this.div.style.position = "absolute";
                containerElementRef.current = this.div;
                const panes = this.getPanes();
                panes === null || panes === void 0 ? void 0 : panes.overlayMouseTarget.appendChild(this.div);
            }
            draw() {
                if (!this.div)
                    return;
                const overlayProjection = this.getProjection();
                const point = overlayProjection.fromLatLngToDivPixel(new google.maps.LatLng(position));
                if (point) {
                    this.div.style.left = `${point.x}px`;
                    this.div.style.top = `${point.y}px`;
                    this.div.style.transform = "translate(-50%, -100%)";
                }
            }
            onRemove() {
                var _a;
                if (this.div) {
                    (_a = this.div.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(this.div);
                    this.div = null;
                    containerElementRef.current = null;
                }
            }
        }
        overlayRef.current = new CustomOverlay();
        overlayRef.current.setMap(map);
        return () => {
            var _a;
            (_a = overlayRef.current) === null || _a === void 0 ? void 0 : _a.setMap(null);
            overlayRef.current = null;
        };
    }, [map, position]);
    return containerElementRef.current
        ? react_dom_1.default.createPortal(children, containerElementRef.current)
        : null;
};
exports.default = MapOverlay;
